
 export default {
  state: {},
  mutations: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/shop.js